import React, { useEffect, useState } from "react";
import { DifficultySelector } from "./DifficultySelector";
import { ModeSelector } from "./ModeSelector";
import { Difficulty, PuzzleMode } from "../../game/usePuzzleStore";

interface PuzzleHudProps {
  startedAt: number | null;
  completedAt: number | null;
  moveCount: number;
  difficulty: Difficulty;
  mode: PuzzleMode;
  onReset: () => void;
  onDifficultyChange: (difficulty: Difficulty) => void;
  onModeChange: (mode: PuzzleMode) => void;
}

export const PuzzleHud: React.FC<PuzzleHudProps> = ({
  startedAt,
  completedAt,
  moveCount,
  difficulty,
  mode,
  onReset,
  onDifficultyChange,
  onModeChange
}) => {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    if (completedAt) return;
    const id = window.setInterval(() => setNow(Date.now()), 500);
    return () => window.clearInterval(id);
  }, [completedAt]);

  const startTime = startedAt ?? now;
  const endTime = completedAt ?? now;
  const elapsedSeconds = Math.max(0, Math.floor((endTime - startTime) / 1000));
  const minutes = Math.floor(elapsedSeconds / 60)
    .toString()
    .padStart(2, "0");
  const seconds = (elapsedSeconds % 60).toString().padStart(2, "0");

  return (
    <div className="stack-v stack-v--gap-sm">
      <header className="stack-h stack-h--gap-md" aria-label="Puzzle status bar">
        <div className="stack-v stack-v--gap-xs" style={{ flex: 1 }}>
          <div className="text-xs text-muted" style={{ textTransform: "uppercase", letterSpacing: "0.08em" }}>
            PulsePuzzles
          </div>
          <div className="stack-h stack-h--gap-sm" style={{ alignItems: "baseline" }}>
            <span className="text-xl" style={{ fontWeight: 650 }}>
              Solo Puzzle
            </span>
            <span className="pill pill--accent text-xs">beta rules</span>
          </div>
        </div>

        <div className="stack-h stack-h--gap-md" style={{ alignItems: "center" }}>
          <div className="stack-v stack-v--gap-xs" aria-label="Elapsed time">
            <span className="text-xs text-muted">time</span>
            <span style={{ fontVariantNumeric: "tabular-nums", fontWeight: 600 }}>
              {minutes}:{seconds}
            </span>
          </div>

          <div className="stack-v stack-v--gap-xs" aria-label="Move count">
            <span className="text-xs text-muted">moves</span>
            <span style={{ fontVariantNumeric: "tabular-nums", fontWeight: 600 }}>{moveCount}</span>
          </div>

          <button className="btn btn--ghost text-xs" type="button" onClick={onReset}>
            restart
          </button>
        </div>
      </header>

      <ModeSelector
        currentMode={mode}
        onSelect={onModeChange}
        disabled={!!completedAt}
      />
      <DifficultySelector
        currentDifficulty={difficulty}
        onSelect={onDifficultyChange}
        disabled={!!completedAt}
      />
    </div>
  );
};


